import { CheckCircleOutlined } from '@ant-design/icons';
import { Button, Result } from 'antd';
import Menu from 'components/QuickTurn/Menu';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { Link } from 'react-router-dom';

const CheckoutSuccess: React.FC = () => (
    <>
        <Menu title="Checkout" />
        <Result
            status="success"
            title="Your order has been received!"
            icon={<CheckCircleOutlined style={{ color: '#1f9f27' }} />}
            extra={[
                <>
                    <Link to="/quick-turn/order-history" className="ant-btn ant-btn-primary">
                        View My Orders
                    </Link>
                </>,
            ]}
        />
    </>
);

export default observer(CheckoutSuccess);
